import dayjs from 'dayjs';
import Utils from 'src/utils';
import { WTS_MOMENT_YEAR_MONTH_MASK } from 'src/constants/dayjs';
export function mergeUserConfirmationPeriods(previousMap, savePayload) {
    const map = { ...previousMap };
    const { period, list } = savePayload;
    const inputPeriod = Utils.periods.periodStringToDayjsRange(period);
    Utils.periods.splitPeriodOntoFullMonths(inputPeriod).forEach((month) => {
        const currentMonth = month[0].format(WTS_MOMENT_YEAR_MONTH_MASK);
        Object.entries(list).forEach(([userId, confirmedPeriods]) => {
            const confirmedPeriodsMap = getConfirmedPeriodsMap(confirmedPeriods);
            map[+userId] = {
                ...map[+userId],
                [currentMonth]: currentMonth in confirmedPeriodsMap
            };
        });
    });
    return map;
}
function getConfirmedPeriodsMap(periods) {
    if (!periods?.length)
        return {};
    return Object.fromEntries(periods.map((p) => {
        return [dayjs(p.StartDate).format(WTS_MOMENT_YEAR_MONTH_MASK), true];
    }));
}
